import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f2a8c7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = { class: "main-content__header" }
const _hoisted_3 = { class: "main-content__sidebar" }

import { ref, provide, onBeforeMount } from "vue";
import { useStore } from "vuex";
import { set } from "@vueuse/core";
import { watchEffect } from "@vue/runtime-core";
import Sidebar from "@/clinic/components/Sidebar.vue";
import Header from "@/clinic/components/Header.vue";
import ConfirmDialog from "primevue/confirmdialog";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainContent',
  setup(__props) {

const store = useStore();
const clinicId = ref(0);

provide("clinicId", clinicId);

const loadClinicId = async () => {
  set(clinicId, await store.dispatch("authClient/getClinicIdCookie"));
};

onBeforeMount(async () => await loadClinicId());

watchEffect(async () => {
  const clinic = store.getters["authClient/selectedClinic"];
  if (clinic === null) return;
  set(clinicId, clinic.id);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Header)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Sidebar)
    ]),
    (_openBlock(), _createElementBlock("div", {
      class: "main-content__content",
      key: clinicId.value
    }, [
      _createVNode(_component_router_view)
    ])),
    _createVNode(_unref(ConfirmDialog))
  ]))
}
}

})